<div [formGroup]="form"
     kalDialogContent>

    <div *ngFor="let control of printOptions.controls; index as i"
         formArrayName="printOptions">

        <div [formGroupName]="i">

            <kal-checkbox formControlName="selected"
                          [label]="control.get('label').value">
            </kal-checkbox>

        </div>

    </div>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">
                        <kal-button (click)="submit()"
                        [disabled]="!isPrintOptionsSelected"
                        id="shared_print_options_Valider"
                        kalTheme="primary">
                Valider
            </kal-button>
        </div>

        <div class="gup-O-list__item">
            <kal-button (click)="close()"
                        id="shared_print_options_Annuler"
                        kalTheme="secondary">
                Annuler
            </kal-button>
        </div>

    </div>

</div>
